import Vue from 'vue'
import Chart from 'chart.js'
import Multiselect from 'vue-multiselect'
import App from './App.vue'
import { clickaway } from './directives'
Vue.config.productionTip = false

Vue.directive('grm-clickaway', clickaway)

Vue.prototype.$chart = Chart

Vue.component('multiselect', Multiselect)

const requireComponent = require.context('./components/sections/', false, /section-[0-9]+\.vue$/)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName = fileName.split('/')
    .pop()
    .replace(/\.\w+$/, '')

  Vue.component(
    componentName,
    componentConfig.default || componentConfig
  )
})

if ('ontouchstart' in window) {
  document.body.classList.add('is-mobile')
  Vue.prototype.$animationEnable = false
} else {
  document.body.classList.add('is-desktop')
  Vue.prototype.$animationEnable = true
}

new Vue({
  render: h => h(App)
}).$mount('#app')
